import type Guid from "@/app/types/common/guid";

import type { PackageType } from "@/app/services/generated/packagetypeService";
import { PackageTypeService } from "@/app/services/generated/packagetypeService";

export default class PackageTypeServiceExtended extends PackageTypeService {
  /**
   * Returns only the package types that are returnable (can be used in container tracking).
   */

  public async getAllReturnablePackageTypes(
    tenantId: Guid
  ): Promise<PackageType[]> {
    return (await this.getAllPackageTypes(tenantId)).filter(
      (pt) => pt.isReturnable
    );
  }

  calculateDutiableLitrePercentage(
    dutiableLitres: number | null,
    packageType: Readonly<PackageType> | null
  ) {
    return dutiableLitres && packageType?.litres
      ? (dutiableLitres / packageType.litres) * 100.0
      : null;
  }

  checkDutiableLitresPercentageOk(dutiableLitresPercentage: number | null) {
    // Allow percentage of
    //  null (Either dutiable litres or package litres not defined)
    //  0% (Dutiable litres 0, sometimes used for duty pre-paid items)
    //  90% to 100% (Within sensible range)
    return (
      dutiableLitresPercentage === null ||
      dutiableLitresPercentage === 0 ||
      (dutiableLitresPercentage >= 90 && dutiableLitresPercentage <= 100)
    );
  }
}

export const packageTypeService = new PackageTypeServiceExtended();
